'use client'
import React from 'react'
import Image from 'next/image'
import LinkComponent from './LinkComponent'
import { sendGAEvent } from '@next/third-parties/google'

const SmallSwiperImage = ({ district, transport, title, slug, imageSrc, route, bgColor = 'bg-maincolortrans' }) => {
    const imageLink = imageSrc || `/images/thonglor.png`

    return (
        <div
            onClick={() => {
                if (route === 'districts') {
                    sendGAEvent({ 
                        event: "select_district",
                        district_id: district.id,
                        district_name: district.subdistrict,
                        district_area: district.district,
                        district_location: district.location,
                        district_type: district.category
                    })
                } else if (route === 'stations') {
                    sendGAEvent({ 
                        event: "select_transport",
                        transport_id: transport.id,
                        transport_name: transport.metaStationName,
                        transport_type: transport.type,
                        transport_code: transport.stationCode,
                        transport_location: transport.location
                    })
                }
            }} 
        >
            <LinkComponent 
                href={`/${route}/${slug}`} 
                className='relative district-swiper-small-image w-[150px] h-[150px]' 
            >
                <div className='w-[140px] h-[140px] relative overflow-hidden rounded-md'>
                    <Image
                        src={imageLink}
                        fill='true'
                        className='object-cover'
                        alt={slug}
                    />
                    <div className='absolute bottom-0 left-0 right-0 rounded-b-md flex justify-center h-[50px] items-start bg-maincolortrans overflow-hidden' style={{ borderTop: `${bgColor} 1px solid` }}>
                        <h3 className={`text-light z-10 px-1 rounded-sm text-md text-center`}>{title}</h3>
                    </div>
                </div>
            </LinkComponent >
        </div>
    )
}

export default SmallSwiperImage